import { render, staticRenderFns } from "./MenuItemsDraggable.vue?vue&type=template&id=6edae4b1&scoped=true&"
import script from "./MenuItemsDraggable.vue?vue&type=script&lang=js&"
export * from "./MenuItemsDraggable.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemsDraggable.vue?vue&type=style&index=0&id=6edae4b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edae4b1",
  null
  
)

export default component.exports